interface Props {
  online: boolean;
  busy: boolean;
  onToggle: () => void;
}

export function OnlineToggle({ online, busy, onToggle }: Props) {
  return (
    <button
      type="button"
      aria-pressed={online}
      onClick={onToggle}
      disabled={busy}
      className={
        'flex w-full items-center justify-between rounded-2xl border px-5 py-5 shadow-card transition ' +
        (online ? 'border-go bg-go/10 text-text' : 'border-line bg-surface text-text')
      }
    >
      <div className="text-left">
        <p className="font-display text-xl font-semibold">{online ? "You're online" : 'You are offline'}</p>
        <p className="text-sm text-muted">
          {online ? 'Listening for ride requests.' : 'Go online to start receiving requests.'}
        </p>
      </div>
      <span
        className={
          'relative inline-flex h-9 w-16 items-center rounded-full transition ' +
          (online ? 'bg-go' : 'bg-line')
        }
        aria-hidden="true"
      >
        <span
          className={
            'inline-block h-7 w-7 transform rounded-full bg-bg shadow transition ' +
            (online ? 'translate-x-8' : 'translate-x-1')
          }
        />
      </span>
    </button>
  );
}
